let currentAccessToken;

export const loadLocalStorage = () => {
	try {
		const fmpSavedState = localStorage.getItem('fmpSavedState');
		if (fmpSavedState === null) {
			return undefined;
		}
		const parsed = JSON.parse(fmpSavedState);

		//- Old way we used to store auth
		if (parsed.user && parsed.user.accessToken) {
			parsed.auth = parsed.user;
			delete parsed.user;
		}
		return parsed;
	} catch (err) {
		console.warn('Problems loading fmpSavedState');
		return undefined;
	}
};

export const saveLocalStorage = (state) => {
	if (!state.auth) {
		return;
	}
	if (state.auth.accessToken === currentAccessToken) {
		return;
	}
	currentAccessToken = state.auth.accessToken;

	try {
		const fmpSavedState = JSON.stringify({
			auth: { accessToken: state.auth.accessToken },
		});
		localStorage.setItem('fmpSavedState', fmpSavedState);
	} catch (err) {
		console.warn('Failed to save fmpSavedState');
	}
};
